import { useContext } from 'react';
import { CollapseDrawerContext } from '../contexts/CollapseDrawerContext';

export default () => useContext(CollapseDrawerContext);
